import React, {useState, useEffect} from 'react';
import FileTable from './FileTable.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemCommentFiles({comment, margin_top}) 
{
    const { action_item, action_item_comment_files } = useCTAL();
    
    const [comment_files, setCommentFiles] = useState([]);
  
    useEffect(() =>
    {
        if (!comment) return;
        if (DEBUG) console.log(`ActionItemCommentFiles*** comment.Type: ${comment.Type}, NumAttachedFiles: ${comment.NumAttachedFiles}`);
        setCommentFiles( action_item_comment_files.filter( item => { return (item.TargetID == comment.CommentID); } ) );
    }, [comment]);

    return (
        <>
            <FileTable files={comment_files} margin_top={margin_top} />                                    
        </>
    );
}